import { useEffect } from 'react';
import { useRouter } from 'next/compat/router';
import { getLoginURL } from '@pass-frontend/common/constants/paths';
import { useCurrentState } from '@pass-frontend/common/data-bridge';

export const useHSIDLoginCheck = () => {
  const { isUserAuthenticated, loading, isQualifiedUser } = useCurrentState();
  const router = useRouter();
  const isAuthenticationInProgress = loading && !isQualifiedUser;

  useEffect(() => {
    // check if the current path needs user to be authenticated. (if prefixed with /member then true)
    const shouldUserBeAuthenticated =
      router?.pathname &&
      router?.pathname.split('/')[1] === 'member' &&
      !isQualifiedUser;

    // if user is unauthenticated and path needs them to re-login, redirect to login page
    if (
      !isUserAuthenticated &&
      shouldUserBeAuthenticated &&
      !loading &&
      !isQualifiedUser
    ) {
      router?.push(getLoginURL(router?.locale));
    }
  }, [isUserAuthenticated, loading, isQualifiedUser]);

  return {
    isUserAuthenticated,
    isAuthenticationInProgress,
    loading,
  };
};
